export default __webpack_public_path__ + "static/media/Montserrat-Regular.7a230c40.woff";